import uuid from "uuid";
import React from "react";

export const uniqueUserId = uuid.v4();
const uniqueIdContext = React.createContext({ userId: uniqueUserId });

export default uniqueIdContext;
